import React from 'react';
import LoginModal from '../modals/LoginModal';
import { Server } from '../../server/server';
import { Navigate } from 'react-router-dom';

class SignUpPage extends React.Component {
  onLoginClose() {
    if(!Server.account.isLoggedIn())
      window.location.href = 'https://marketing.oneclick.community';
  }

  render() {
    if(Server.account.isLoggedIn())
      return <Navigate to="/dashboard" />

    return(
      <div className="site-page">
        <LoginModal mode={'signup'} onClose={()=>this.onLoginClose()}/>
      </div>
    )
  }
}

export default SignUpPage;